import { generate } from '@/utils/request';
const config = {
  prefix: '/iam',
  items: [
    // 获取客户存储容量
    { key: 'getCusCcList', url: '/v1/{organizationId}/customerStorage/page', method: 'POST' },
  ],
};

export default {
  ...generate(config),
};
